if (!customElements.get('hp-rain-paint')) {
  customElements.define('hp-rain-paint', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.code = this.querySelector('input');
      this.update = () => {
        const paint = this.info.querySelector('select[name="options[Paint]"]');
        const painted = paint?.value === 'Painted (+$250)';
        this.hidden = !painted;
        this.code.disabled = !painted;
        this.code.required = painted;
      };
      this.validate = event => {
        if (event.target.id !== this.code.getAttribute('form')) return;
        this.update();
        if (!this.code.disabled && !this.code.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.code.setCustomValidity(this.dataset.error);
          this.code.reportValidity();
        }
      };
      this.clearError = () => this.code.setCustomValidity('');
      this.info.addEventListener('change', this.update);
      this.info.addEventListener('submit', this.validate, true);
      this.code.addEventListener('input', this.clearError);
      this.update();
    }
    disconnectedCallback() {
      this.info?.removeEventListener('change', this.update);
      this.info?.removeEventListener('submit', this.validate, true);
      this.code?.removeEventListener('input', this.clearError);
    }
  });
}
